export const API = {
	EVENT_LIST: '/scan/events',
	SESSION_LIST: '/scan/sessions',
	CONSUME: '/scan/consume',
	SEARCH: '/scan/search',
}
